// rem等比适配配置文件
// 设计基准：1920px 宽 → html.fontSize = 16px（1:1）
// 只按宽度缩放：管理后台高度允许滚动，不需要 scaleY，避免浏览器 UI 占位导致字号缩小/模糊
const baseSize = 16
let remScale: number

function setRem () {
  const designWidth = 1920
  const designHeight = 1080
  const designRatio = designWidth / designHeight // 16:9

  const clientWidth = document.documentElement.clientWidth
  const clientHeight = document.documentElement.clientHeight
  const clientRatio = clientWidth / clientHeight

  // 根据实际屏幕宽高比与设计稿比例的比较，选择按宽度或高度缩放
  const scale = clientRatio > designRatio
    ? clientHeight / designHeight // 宽屏，按高度缩放
    : clientWidth / designWidth // 窄屏，按宽度缩放

  // 取整避免小数 px 导致亚像素渲染模糊；上限 2 防止超大屏字号失控
  const fontSize = Math.round(baseSize * Math.min(scale, 2))
  document.documentElement.style.fontSize = fontSize + 'px'
  remScale = fontSize
}

// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.addEventListener('resize', setRem)

export default function (px: number) {
  return px * remScale
}
